import StateManager from "Apollo/StateManager";
import { ShowroomUserViewSamplesFormUi } from "generated/graphql";
import initialState from "./state";

const stateManager = new StateManager('showroom.userView.samples.form');

export const updateRequestSamplesForm = (params: Partial<ShowroomUserViewSamplesFormUi>) => {
	stateManager.update({ ...params });
};

export const clearRequestSamplesForm = () => stateManager.update(initialState);